<div class="outer-container" [ngClass]="{ visible }">
  <div class="progress-container">
    @if (message) {
      <div class="message">{{ message }}</div>
    }
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="4" />
  </div>
</div>
